// Canonical locator page — promotes the Phase 0 /poc/map content.
// We re-export the existing MapPage to avoid duplication.
import MapPage from "./MapPage";

export default function FindUs() {
  return <MapPage />;
}
